/* eslint-disable consistent-return */

import Component from '@bythepixel/component-loader';
import Animations from '@Front/animations';

const DEFAULTS = {
  optionsSelector: '[data-comp-animation-options]',
};

export default class AnimationController extends Component {
  static selector = '[data-comp-animation]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.animationName = containerEl.dataset.compAnimation || '';
    this.animationOptions = this.#getOptions();
    this.mount();
  }

  #getAnimations() {
    return Object.keys(Animations);
  }

  #animationExists(animationName) {
    return this.#getAnimations().includes(animationName);
  }

  #animationNotFound() {
    const animationNames = this.#getAnimations();
    const formattedNames = animationNames.map(name => `\t- ${name}`);

    console.warn(
      `AnimationController: Animation '${this.animationName}' not found in Animations\n\n`,
      'Available animations are:\n\n',
      formattedNames.join('\n'),
    );
  }

  #getOptions() {
    const options = this.$container.dataset.compAnimationOptions;
    if (!options) return;

    try {
      const parsedOptions = JSON.parse(options);
      return parsedOptions;
    } catch (err) {
      console.error(err);
    }
  }

  mount() {
    if (!this.#animationExists(this.animationName)) {
      this.#animationNotFound();
    }

    Animations[this.animationName](this.$container, this.animationOptions);
  }
}
